var map = {
	"./A.gif": 962,
	"./B.gif": 773,
	"./C.gif": 516,
	"./D.gif": 327,
	"./E.gif": 518,
	"./F.gif": 809,
	"./G.gif": 312,
	"./H.gif": 203,
	"./I.gif": 882,
	"./J.gif": 21,
	"./K.gif": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;